import { api } from '../../../axios';

export const fetchPackages = async (token: string) => {
  const response = await api.get(
    'bx_block_contentmanagement/package_managements?data=package_checklists',
    { headers: { token } }
  );
  return response.data;
};
